import { Box } from 'morphe';

export default function EmptyBox() {
  return <Box />;
}
